module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/step2_bg_right-923efd012ff1f5c69db4a836d3263438.png";